/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { useEffect, useRef, useState } from 'react';

export function useTextTruncation(text: string) {
  const [isTextTruncated, setTextTruncated] = useState(false);
  const textRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const checkTextTruncation = () => {
      const element = textRef.current;
      const isTruncated = element ? element.scrollWidth > element.clientWidth : false;
      setTextTruncated(isTruncated);
    };

    checkTextTruncation();

    // Listener to re-check on window resize
    window.addEventListener('resize', checkTextTruncation);

    return () => {
      window.removeEventListener('resize', checkTextTruncation);
    };
  }, [text]);

  return { isTextTruncated, textRef };
}
